export const validateEtag = (obj) => {
  return obj.Etag
}
